export default __webpack_public_path__ + "static/media/arrow_right.efa20ab6.svg";